import { Component, Input } from '@angular/core';
import { OmniDashboard } from 'src/app/my-sedgwick';
import { BaseComponent } from 'src/app/shared';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';

@Component({
    selector: 'app-pending-accommodations-card',
    template: `
    <app-panel
      [border]="'Empty'"
      class="tw-cursor-pointer"
      (click)="
        FeatureLogging(
          'PendingAccommodations',
          'Pending Accommodations',
          'Summary View Card'
        )
      "
      [shadow]="true"
      routerLink="pending-accommodations"
      [canExpand]="false"
      tabindex="-1"
    >
      <div
        class="tw-flex tw-flex-col tw-justify-center tw-items-center  tw-bg-[var(--sed-warm-white-color)] container"
      >
        <app-loading-panel
          [state]="omniDashboard ? 'Loaded' : 'Loading'"
          loadingStyle="DotWhite"
          [error]="error"
        >
          <ng-template #content>
            <div class="tw-flex tw-flex-col tw-items-center">
              <h2 class="tw-text-[26px] app-mt8 tw-font-light ">
                {{ 'Pending Accommodations' | titlecase | translation: translationRequest }}
              </h2>
              <div
                class="tw-text-[140px] tw-font-bold tw-leading-none tw-text-[var(--sed-black-80-color)]"
              >
                {{ omniDashboard.pendingAccommodations }}
              </div>
              <div class="tw-text-[13px] tw-leading-none tw-font-light"></div>
              <div class="app-mb5 app-pt4">
                <app-button
                  emphasis="High"
                  arialabel="Go to Pending Accommodations details page"
                  [role]="'link'"
                  label="View Details"
                >
                </app-button>
              </div>
            </div>
          </ng-template>
        </app-loading-panel>
      </div>
    </app-panel>
  `,
    styles: [
        `
      .container {
        height: 425px;
      }
    `,
    ],
    standalone: false
})
export class PendingAccommodationsCardComponent extends BaseComponent {
  @Input()
  omniDashboard: OmniDashboard;
  
  @Input()
  translationRequest: TranslationRequest;

  @Input()
  error: any;

  constructor() {
    super();
  }
}
